import '../styles/form.css';
import { useState, useEffect, useRef } from 'react';
import 'react-phone-input-2/lib/style.css';
import apiService from '../services/api.service';
import Message from './message';
import Input from './input';
import brands from '../brands.json';


import { validateForm } from '../utils/validation';

const DynamicForm = ({ formType, fields, title, introText }) => {
  const homePage = `https://${brands[process.env.REACT_APP_BRAND].homePage}`;
  const brand = process.env.REACT_APP_BRAND;
  const brandArabic = brands[brand].arabic_name
  const brandWarranty = brands[brand].warranty
  const fileInputRef = useRef(null); // Create a ref for file input
  const initialFormData = fields.reduce((acc, field) => {
    acc[field.id] = field.type === 'file' ? null : '';
    if (field.type === 'phone') {
      acc['countryCode'] = '+966';
      acc['mobile'] = '+966'; // Set mobile field to the default country code

    }
    return acc;
  }, {});
  title = formType === 'Ambassadors' || formType === 'Warranty' ?` ${title} ${brandArabic}`: title
  const [formData, setFormData] = useState(initialFormData);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = title; // Set the title dynamically based on form type
    // Set the favicon dynamically
  const favicon = document.querySelector("link[rel='icon']");
  const newIcon = "/images/logo_"+brand+".png" // Replace with the desired icon URL
  console.log('logo path: ',newIcon)
  if (favicon) {
    favicon.href = newIcon;
  } else {
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = newIcon;
    document.head.appendChild(link);
  }
    
  }, [title]);

  const handleInputChange = (e) => {
    const { id, value, type, files } = e.target;
  
    // Check if the id corresponds to a social media platform
    const socialMediaPlatforms = ['facebook', 'x', 'instagram', 'tiktok', 'snapchat'];
  
    if (socialMediaPlatforms.includes(id)) {
      // If it's a social media platform, save it under 'socialMediaAccount'
      setFormData({
        ...formData,
        socialMediaAccount: value, // Save the value as socialMediaAccount
      });
    } else {
      // For other inputs (like file, text, etc.), proceed as usual
    if (type === 'file' && files) {
      const file = files[0];

      // Check if the file size exceeds 200 KB
      if (file.size > 200 * 1024) {
        setErrorMessage("حجم الملف يجب ألا يزيد عن 200 كيلوبايت" );
        return; // Prevent further processing
      } 
      

      // Handle file input separately
      setFormData({
        ...formData,
        [id]: file, // Save the first selected file
      });
      } else {
        // Handle regular inputs (text, phone, etc.)
        setFormData({
          ...formData,
          [id]: value,
        });
      }
    }
  };
  

  const handlePhoneChange = (value, countryData) => {
    setFormData({
      ...formData,
      mobile: value,
      countryCode: countryData.countryCode,
    });
  };

  
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setIsLoading(true);
    console.log('formData: ',formData)
    const errors = validateForm(fields, formData);
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setIsLoading(false);
      return;
    }

    try {
      const formDataToSend = { ...formData, formType, brand };
      const fileField = Object.keys(formData).find((key) => formData[key] instanceof File);

      if (fileField) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', formData[fileField]);

        console.log(`Uploading file for: ${fileField}`);
        const uploadResponse = await apiService.uploadFiles(uploadFormData);

        if (uploadResponse?.data?.url) {
          const urlKey = `${fileField}Url`; // Dynamically create the key for the file URL
          formDataToSend[urlKey] = uploadResponse.data.url; // Assign the uploaded URL
        } else {
          throw new Error('File upload failed');
        }
      }

      await apiService.submitFormData(formDataToSend); // Unified API call
      setSuccessMessage('تم إرسال البيانات بنجاح!');
      setFormData(initialFormData);
      // Reset the file input manually
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Reset file input value
      }
       // Wait for 3 seconds and redirect to the external homepage
       setTimeout(() => {
        window.location.href = homePage; // Redirect to the external URL
      }, 3000);
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrorMessage('حدث خطأ أثناء إرسال البيانات. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsLoading(false);
    }
  };
  console.log(' intro: ', introText)
   // Replace {brand} in introText with the actual brand
   const formattedIntroText = introText
   ? introText.replace(/{brand}/g, brandArabic).replace(/{brandWarranty}/g,brandWarranty) // This will replace all instances of {brand}
   : '';

  return (
    <div className="form-wrapper">
      <h4 className="form-title">{title}</h4>
      {
        formattedIntroText && <div className="enhanced-title-border">
        <span className="circle"></span>
      </div>
      }
      {formattedIntroText && (
        <div className={`intro-text ${formType === 'Warranty' ? 'center-text' : ''}`}>
        {formattedIntroText.split('\n').map((line, index) => {
            // Check if the line starts with a bullet point
            if (line.trim().startsWith('•')) {
              return (
                <ul key={index}>
                  <li>{line.replace('•', '').trim()}</li> {/* Remove bullet and render as list item */}
                </ul>
              );
            }

            // Otherwise render as regular paragraph
            return <p key={index}>{line}</p>;
          })}
        </div>
      )}
        <form onSubmit={handleSubmit} className="form-container">
        {fields.map((field) => {
  // Skip rendering this field if it has a dependency and the condition is not met
  if (field.dependentOn) {
    const dependentValue = formData[field.dependentOn];
    if (!field.dependencyValues.includes(dependentValue)) {
      return null; // Skip this field if the condition is not met
    }
  }

  return (
    <Input
      key={field.id}
      type={field.type}
      id={field.id}
      value={field.type === 'social-media' ? formData.socialMediaAccount || '' : formData[field.id] || ''}
      onChange={field.type === 'phone' ? handlePhoneChange : handleInputChange}
      placeholder={field.placeholder}
      options={field.options}
      acceptFiles={field.acceptFiles}
      required={field.required}
      ref={field.type === 'file' ? fileInputRef : null} // Attach ref to file input
      min={field.min}
      max={field.max}
    />

  
  );
})}
        <Message messageType="error" messageText={errorMessage} />
        <Message messageType="success" messageText={successMessage} />
        {isLoading && <Message messageType="loading" messageText="جاري التحميل..." />}
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'جاري الإرسال...' : 'إرسال'}
        </button>
      </form>
    </div>
  );
};

export default DynamicForm;
